module.exports = __webpack_public_path__ + "img/ring_y_l_0_1@3x.262f79df.png";